<template>
    <div id="app" class="17_9_google">
        <router-view></router-view>
    </div>
</template>

<script type="application/javascript">
import { WOW } from 'wowjs'
import config from './config'

export default {
  name: 'app',
  data() {
    return {
      config
    }
  },
  methods: {
    goToPage(index) {
      this.$router.push({
        path: '/enterprise_Intr',
        query: {
          tab: index
        }
      })
    }
  },
  mounted() {
    this.$nextTick(() => { // 在dom渲染完后,再执行动画
      const wow = new WOW({live: false})
      wow.init()
    })
    document.title = this.config.tenantName
    document.documentElement.style.fontSize = document.documentElement.clientWidth / (12.5) + 'px'
  }
}
</script>

<style scoped>
    @import "./css/all.css";
    @import "./css/animate.min.css";
</style>
